import {PureComponent} from 'react';
import Referrals from './Referrals';

export default class MyProfile extends PureComponent {
    static Referrals = Referrals;
}
